import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Problem = ({
  openModal
}) => {
  // Add the openModal prop and the helper function
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-173">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-174">
      <p className="mb-6 leading-relaxed" data-id="element-175">
        Marieke staarde naar het bericht op haar scherm. Ze las de woorden drie
        keer voordat ze het begreep.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-176">
        David L. Mech (de man achter de beroemde dominantie theorie) had een
        openbare verklaring afgelegd die haar jarenlange aanpak volledig
        onderuit haalde.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-177">
        "Mijn dominantie theorie is niet van toepassing op honden. Het spijt me
        dat dit misverstand zo wijdverspreid is geworden onder hondeneigenaren."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-178">
        Marieke voelde zich duizelig worden. Vijf jaar lang had ze geprobeerd de
        "alfaleider" te zijn voor haar golden retriever Luna. Streng zijn
        wanneer nodig. Consequent corrigeren. Dominantie tonen.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-179">
        Precies zoals elke trainer, elk boek, elke hondenschool haar had
        geleerd.
      </p>
      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-180">
        Maar nu vertelde de grondlegger van deze hele theorie dat het niet eens
        waar was?
      </p>
    </section>;
};